import { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Toaster } from '@zawarski/eti-ui';
import { store } from '@store/index';
import { ThemeProvider } from '@hooks/useThemeQuery';
import AuthGate from '@auth/AuthGate';
import { PageLoading } from '@components/layout/PageScaffold';
import AppRoutes from './AppRoutes';
import './index.css';
import '@zawarski/eti-ui/styles.css';

const SelfRegistration = lazy(() => import('@pages/Public/SelfRegistration'));

/**
 * Application root: store, theme, router. The public self-registration page
 * renders without a session; everything else sits behind the portal id_token
 * gate, which verifies the token and resolves the caller's REP access before
 * any page renders.
 */
const ReduxIndex = ({ initialToken }: { initialToken?: string }) => (
  <div id='rep-root' className='rep:h-full rep:w-full rep:bg-background'>
    <Provider store={store}>
      <ThemeProvider>
        <Toaster richColors position='top-right' />
        <BrowserRouter>
          <Routes>
            <Route
              path='/self-register'
              element={
                <Suspense fallback={<PageLoading />}>
                  <SelfRegistration />
                </Suspense>
              }
            />
            <Route
              path='*'
              element={
                <AuthGate initialToken={initialToken}>
                  <AppRoutes />
                </AuthGate>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </div>
);

export default ReduxIndex;
